import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import area from './modules/area'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    setting,
    area,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js